import { render, staticRenderFns } from "./CatalogsColumnsModal.vue?vue&type=template&id=7bfd94b9&scoped=true"
import script from "./CatalogsColumnsModal.vue?vue&type=script&lang=js"
export * from "./CatalogsColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd94b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bfd94b9')) {
      api.createRecord('7bfd94b9', component.options)
    } else {
      api.reload('7bfd94b9', component.options)
    }
    module.hot.accept("./CatalogsColumnsModal.vue?vue&type=template&id=7bfd94b9&scoped=true", function () {
      api.rerender('7bfd94b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CatalogsColumnsModal.vue"
export default component.exports